export const minLength = (num) => (val) => {
  if (!val) return true;
  return val.length >= num;
};
export const maxLength = (num) => (val) => {
  if (!val) return true;
  return val.length <= num;
};
export const required = (_val) => {
  const val = _val.trim().replace(/\s+/g, " ");
  return val ? true : false;
};
export const checkEmail = (email) => !email || /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email);

//export const requiredTxt = (name) => `"${name}" обязательное поле`;
